<template>
  <div>
    <button class="btn btn-config" @click="show_modal">
      <i class="fas fa-cog" />
    </button>
    <modal-vue :visible.sync="is_visible" :content_loaded="true">
      <template v-slot:header>
        {{ t("components.calendars.config_modal.title") }}
        <button class="edit-close" @click="hide_modal">
          <i class="fa fa-times"></i>
        </button>
      </template>

      <template v-slot:body>
        <loader-vue v-if="loading" :visible="true"/>
        <transition name="fade" mode="out-in">
          <div v-if="list_mode" key="list">
            <div class="d-flex border-bottom align-items-center py-1" v-for="calendar in calendars" :key="calendar.id">
              <div class="calendar-dot mr-2" :style="{'background-color': calendar.color}" />
              <span class="mr-auto m-1">{{ calendar.name }}</span>
              <button class="btn btn-outline-primary m-1" @click="edit(calendar)">
                <i class="fas fa-pen" />
              </button>
              <button class="btn btn-outline-primary m-1"  @click="remove(calendar)">
                <i class="far fa-trash-alt" />
              </button>
            </div>
            <div v-for="error in errors" :key="error.name" :style="{color: 'red'}">
              {{ error.message }}
            </div>
            <div class="modal-content__create-button">
              <button class="btn btn-primary mt-3" @click="create">
                <i class="fas fa-plus" />
                {{ t("components.calendars.config_modal.new") }}
              </button>
            </div>
          </div>
          <calendars-calendar-edit-vue v-else @end="end" v-bind="selected_calendar" key="update"/>
        </transition>
      </template>

      <template v-slot:footer>
        <button class="btn close-btn" @click="hide_modal">
          {{ t("cerrar") }}
        </button>
      </template>
    </modal-vue>

    <confirmation-modal-vue
      ref="delete_calendar_confirmation_modal"
      :title="t('components.calendars.config_modal.delete_title')"
      @confirmation:clicked="handle_confirmation_clicked">
      {{ t("components.calendars.config_modal.delete_body") }}
    </confirmation-modal-vue>
  </div>
</template>

<script>
import mixins from "common/mixins";
import { mapState, mapActions } from 'vuex'

export default {
  mixins: [mixins.translate],
  name: "calendars-config-modal-vue",
  components: {
    "calendars-calendar-edit-vue": () => import( /* webpackChunkName: "[request]" */ "components/calendars/CalendarEdit"),
    "confirmation-modal-vue": () => import( /* webpackChunkName: "[request]" */ "components/ConfirmationModal"),
    "modal-vue": () => import(/* webpackChunkName: "[request]" */ "components/Modal"),
    "loader-vue": () => import(/* webpackChunkName: "[request]" */ "components/Loader")
  },
  data() {
    return {
      is_visible: false,
      selected_calendar: {},
      list_mode: true
    }
  },
  computed: {
    ...mapState("calendars", ["calendars", "loading", "errors"])
  },
  methods: {
    show_modal() {
      this.is_visible = true
      this.list_mode = true
    },
    hide_modal() {
      this.is_visible = false
    },
    create() {
      this.selected_calendar = {}
      this.list_mode = false
    },
    edit(calendar) {
      this.selected_calendar = calendar
      this.list_mode = false
    },
    remove(calendar) {
      this.selected_calendar = calendar
      this.$refs.delete_calendar_confirmation_modal.show()
    },
    end() {
      this.list_mode = true
    },
    handle_confirmation_clicked({ confirmed }) {
      if(confirmed) this.delete_calendar(this.selected_calendar) 
    },
    ...mapActions("calendars", ["delete_calendar"]),
  }
}
</script>

